module.exports = __webpack_public_path__ + "static/logo-white-2a56f47d6ad0e024f98d20c2c1e30df7.png";